const getDefaultState = () => {
  return {
    senha_atendimento: {},
    logging: {},
    relatorio_cancelados: {},
  }
}

export const params = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    RESET_STATE(state) {
      Object.assign(state, getDefaultState())
    },
    UPDATE_PARAMS(state, { key, params }) {
      state[key] = params
    },
  },
}
